var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "0%",
    x2: "100%",
    y1: "49.97%",
    y2: "49.97%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#231F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#034EA2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotel_User_part_UI",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_Results_modify_01",
    transform: "translate(-450 -1938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Footers/v1",
    transform: "translate(0 1629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(165 271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Links",
    transform: "translate(285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 50.83,
    height: 38.05,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#9DADBC",
    strokeOpacity: 0.36,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("g", {
    id: "visa-seeklogo.com",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    transform: "translate(6 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.536.213 9.52 12.179H6.258L3.794 2.64c-.142-.585-.284-.797-.727-1.046C2.305 1.188 1.08.798 0 .567L.07.213h5.266c.674 0 1.276.443 1.418 1.223L8.066 8.35 11.292.213h3.244Zm12.817 8.066c.018-3.156-4.36-3.333-4.343-4.734.018-.425.425-.886 1.312-1.01.443-.053 1.666-.106 3.049.532l.55-2.535C27.175.266 26.218 0 25.03 0c-3.05 0-5.212 1.63-5.23 3.953-.017 1.72 1.543 2.677 2.713 3.262 1.205.585 1.613.957 1.613 1.49-.018.797-.957 1.151-1.844 1.17-1.56.017-2.464-.426-3.173-.763l-.567 2.623c.727.337 2.056.62 3.439.639 3.244 0 5.353-1.614 5.371-4.095m8.084 3.9h2.854L35.79.213H33.15c-.603 0-1.1.337-1.312.868l-4.644 11.08h3.244l.638-1.79h3.97l.39 1.808ZM31.98 7.942l1.63-4.485.94 4.485h-2.57ZM18.95.212 16.398 12.18h-3.085L15.866.213h3.084Z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.cee8c937a5cc91a1fadf17feaf57fb31.svg";
export { ForwardRef as ReactComponent };